import { render, staticRenderFns } from "./ValidationMessage.vue?vue&type=template&id=416383d8"
import script from "./ValidationMessage.vue?vue&type=script&lang=js"
export * from "./ValidationMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports